<template>
    <div>
        <first-report v-if="parseInt(this.$route.params.id) === 1"></first-report>
        <second-report v-if="parseInt(this.$route.params.id) === 2"></second-report>
        <third-report v-if="parseInt(this.$route.params.id) === 3"></third-report>
        <fourth-report v-if="parseInt(this.$route.params.id) === 4"></fourth-report>
        <fifth-report v-if="parseInt(this.$route.params.id) === 5"></fifth-report>
        <sixth-report v-if="parseInt(this.$route.params.id) === 6"></sixth-report>
        <seventh-report v-if="parseInt(this.$route.params.id) === 7"></seventh-report>
        <eighth-report v-if="parseInt(this.$route.params.id) === 8"></eighth-report>
    </div>
</template>

<script>
import FirstReport from "@/pages/Devices/components/ReportTypes/FirstReport";
import SecondReport from "@/pages/Devices/components/ReportTypes/SecondReport";
import ThirdReport from "@/pages/Devices/components/ReportTypes/ThirdReport";
import FourthReport from "@/pages/Devices/components/ReportTypes/FourthReport";
import FifthReport from "@/pages/Devices/components/ReportTypes/FifthReport";
import SixthReport from "@/pages/Devices/components/ReportTypes/SixthReport";
import SeventhReport from "@/pages/Devices/components/ReportTypes/SeventhReport";
import EighthReport from "@/pages/Devices/components/ReportTypes/EighthReport";

export default {
    name: "ReportTypeDetails",
    components: {
        FifthReport,
        FourthReport,
        FirstReport,
        SecondReport,
        ThirdReport,
        SeventhReport,
        SixthReport,
        EighthReport,
    }
}
</script>

<style scoped>

</style>
